import { arrayOf, number, string } from 'prop-types';
import React from 'react';

import ConnectedCampaignLine from '../CampaignLine.container';

function CountryLine({ label, lines, ...rest }) {
  return lines.map(line => (
    <ConnectedCampaignLine key={line} id={line} label={label} {...rest} />
  ));
}

CountryLine.propTypes = {
  label: string.isRequired,
  lines: arrayOf(number),
};

CountryLine.defaultProps = {
  lines: [],
};

export default React.memo(CountryLine);
